import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import MeaButton from "../../../../components/MeaButton";
import { classTagStyle, formatSlotLabel } from "../slotChangeUtils";
import "./SlotPreferencePicker.css";

const SlotPreferencePicker = ({
  options,
  value,
  onChange,
  disabled,
  placeholder,
}) => {
  const selectedIds = value || [];
  const selected = selectedIds.map((id) => {
    const option = (options || []).find((entry) => entry.id === id);
    if (option) {
      return option;
    }
    return {
      id,
      label: "Créneau",
      slot: null,
      classes: [],
    };
  });
  const available = (options || []).filter(
    (option) => !selectedIds.includes(option.id)
  );

  const renderOption = (option) => {
    if (!option) {
      return null;
    }

    const slotLabel =
      formatSlotLabel(option.slot) !== "-" ? formatSlotLabel(option.slot) : option.label;

    return (
      <div className="slot-preference-picker-option">
        <div className="slot-preference-picker-option-label">{slotLabel}</div>
        {option.classes?.length ? (
          <div className="slot-preference-picker-option-classes">
            {option.classes.map((classe) => (
              <Tag
                key={classe.id}
                value={classe.name}
                style={classTagStyle(classe)}
                className="text-xs"
              />
            ))}
          </div>
        ) : null}
      </div>
    );
  };

  const move = (index, direction) => {
    const next = [...selectedIds];
    const target = index + direction;
    if (target < 0 || target >= next.length) {
      return;
    }
    const tmp = next[index];
    next[index] = next[target];
    next[target] = tmp;
    onChange(next);
  };

  return (
    <div className="mb-3">
      <Dropdown
        value={null}
        options={available}
        optionLabel="label"
        optionValue="id"
        itemTemplate={renderOption}
        filter
        disabled={disabled || !available.length}
        placeholder={placeholder}
        appendTo={typeof document !== "undefined" ? document.body : undefined}
        panelClassName="slot-preference-picker-panel"
        onChange={(e) => {
          if (e.value && !selectedIds.includes(e.value)) {
            onChange([...selectedIds, e.value]);
          }
        }}
        className="w-full slot-preference-picker-dropdown"
      />
      {selected.length > 0 && (
        <div className="mt-2 slot-preference-picker-selected-list">
          {selected.map((option, index) => (
            <div
              key={option.id}
              className="slot-preference-picker-selected-item flex align-items-center justify-content-between border-round border-1 surface-border px-2 py-1 mb-1"
            >
              <div className="slot-preference-picker-selected-content">
                <div>
                  <strong className="mr-2">{index + 1}.</strong>
                  {formatSlotLabel(option.slot) !== "-"
                    ? formatSlotLabel(option.slot)
                    : option.label}
                </div>
                {option.classes?.length ? (
                  <div className="flex flex-wrap gap-1 mt-1">
                    {option.classes.map((classe) => (
                      <Tag
                        key={classe.id}
                        value={classe.name}
                        style={classTagStyle(classe)}
                        className="text-xs"
                      />
                    ))}
                  </div>
                ) : null}
              </div>
              <div className="slot-preference-picker-actions flex gap-1">
                <MeaButton
                  icon="pi pi-chevron-up"
                  rounded
                  text
                  disabled={disabled || index === 0}
                  style={{ padding: 0, height: "1.5rem" }}
                  onClick={() => move(index, -1)}
                />
                <MeaButton
                  icon="pi pi-chevron-down"
                  rounded
                  text
                  disabled={disabled || index === selected.length - 1}
                  style={{ padding: 0, height: "1.5rem" }}
                  onClick={() => move(index, 1)}
                />
                <MeaButton
                  icon="pi pi-times"
                  rounded
                  text
                  severity="danger"
                  disabled={disabled}
                  style={{ padding: 0, height: "1.5rem" }}
                  onClick={() =>
                    onChange(selectedIds.filter((id) => id !== option.id))
                  }
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SlotPreferencePicker;
